"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionRender = void 0;
var js_1 = require("@mdi/js");
var react_1 = __importDefault(require("@mdi/react"));
var react_2 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var __1 = require("../../..");
var calendar_1 = __importDefault(require("../calendar"));
var DBCards_1 = require("./DBCards");
var DBTable_1 = require("./DBTable");
var CollectionRender = function (_a) {
    var path = _a.path, tableProps = _a.tableProps, cardProps = _a.cardProps, intel = _a.intel, views = _a.views, Empty = _a.Empty;
    var theme = (0, __1.useEloise)().theme;
    var _b = (0, react_2.useState)("table"), mode = _b[0], setMode = _b[1];
    var logic = (0, __1.useEloise)().logic;
    var _c = (0, react_2.useState)([]), vtu = _c[0], setVtu = _c[1];
    var _d = (0, react_2.useState)(), docs = _d[0], setDocs = _d[1]; // added this line
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var test_1, dtu;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(views !== "auto")) return [3 /*break*/, 1];
                    setVtu(views);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, logic.fb.docs.getUserCollection(path)];
                case 2:
                    test_1 = _a.sent();
                    setDocs(test_1); // added this line
                    if (test_1) {
                        dtu = test_1[0];
                        setVtu(determineDisplayType(dtu));
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var cts = function () {
        if (docs && docs.length === 0 && Empty) {
            // added this line
            return react_2.default.createElement(Empty, null);
        }
        else if (mode === "table") {
            return (react_2.default.createElement(DBTable_1.DBTable, __assign({ path: path }, tableProps)));
        }
        else if (mode === "calendar") {
            return (react_2.default.createElement(calendar_1.default, { path: path, onNew: function () { } }));
        }
        else {
            return (react_2.default.createElement(DBCards_1.DBCards, __assign({ path: path }, cardProps)));
        }
    };
    return (react_2.default.createElement(__1.EloiseWidget, { eloiseIntel: __assign({}, intel) },
        react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement(react_bootstrap_1.Row, { className: "my-3" },
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 2 },
                    react_2.default.createElement(__1.Heading, { align: "left", size: 3 }, logic.generic.capitalize(path))),
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 2, className: "row" },
                    mode !== "table" && views.includes("table") && (react_2.default.createElement("div", { onClick: function () { return setMode("table"); }, className: "col" },
                        react_2.default.createElement(react_1.default, { path: js_1.mdiTable, color: theme.colors[0], size: 1.5 }))),
                    mode !== "cards" && views.includes("cards") && (react_2.default.createElement("div", { onClick: function () { return setMode("cards"); }, className: "col" },
                        react_2.default.createElement(react_1.default, { path: js_1.mdiCards, color: theme.colors[0], size: 1.5 }))),
                    mode !== "calendar" && views.includes("calendar") && (react_2.default.createElement("div", { onClick: function () { return setMode("calendar"); }, className: "col" },
                        react_2.default.createElement(react_1.default, { path: js_1.mdiCalendar, color: theme.colors[0], size: 1.5 })))),
                react_2.default.createElement(react_bootstrap_1.Col, { lg: 6 })),
            cts())));
};
exports.CollectionRender = CollectionRender;
function determineDisplayType(obj) {
    var displayOptions = {
        cards: ["title", "image", "description"],
        table: ["header", "rows"],
        calendar: ["events", "date"],
    };
    if (typeof obj !== "object" || obj === null) {
        return [];
    }
    var objectKeys = Object.keys(obj);
    return Object.keys(displayOptions).reduce(function (acc, displayType) {
        var requiredKeys = displayOptions[displayType];
        if (requiredKeys.every(function (key) { return objectKeys.includes(key); })) {
            acc.push(displayType);
        }
        return acc;
    }, []);
}
